export function ToggleML(){
    const ml = document.querySelector('.mention')
    ml.classList.toggle('active_mention')
}
export function ToggleRGPD(){
    const rgpd = document.querySelector('.rgpd')
    rgpd.classList.toggle('active_rgpd')
}

